// v2/utils/api.js
// Tum v2 API cagrilari buradan gecer. Bearer token otomatik eklenir,
// 401/403 gelirse oturum temizlenip login sayfasina yonlendirilir.

import { oturumBilgisi, oturumuSonlandir } from './authStore';

export const API_BASE = '/api';

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export const OTURUM_BITTI = 'SESSION_EXPIRED';

function basliklariKur(ekstra, jsonGonderiliyor) {
  const { token } = oturumBilgisi();
  const h = { ...(ekstra || {}) };
  if (jsonGonderiliyor) h['Content-Type'] = 'application/json';
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

async function istek(yol, { method = 'GET', body, headers, signal, oturumsuz = false } = {}) {
  const formVeri = typeof FormData !== 'undefined' && body instanceof FormData;
  const jsonGonderiliyor = body !== undefined && body !== null && !formVeri;

  let res;
  try {
    res = await fetch(`${API_BASE}${yol}`, {
      method,
      headers: basliklariKur(headers, jsonGonderiliyor),
      body: formVeri ? body : jsonGonderiliyor ? JSON.stringify(body) : undefined,
      signal,
    });
  } catch (e) {
    if (e && e.name === 'AbortError') throw e;
    throw new ApiError('Sunucuya ulasilamadi', 0, null);
  }

  // Oturum dustu -> temizle ve login'e don (login/logout cagrilari haric)
  if ((res.status === 401 || res.status === 403) && !oturumsuz) {
    oturumuSonlandir();
    throw new ApiError(OTURUM_BITTI, res.status, null);
  }

  let veri = null;
  const tur = res.headers.get('content-type') || '';
  try {
    veri = tur.includes('application/json') ? await res.json() : await res.text();
  } catch (e) {
    veri = null;
  }

  if (!res.ok) {
    const mesaj =
      (veri && (veri.message || veri.error)) || `Istek basarisiz (${res.status})`;
    throw new ApiError(mesaj, res.status, veri);
  }

  return veri;
}

export const apiGet = (yol, opts) => istek(yol, { ...(opts || {}), method: 'GET' });
export const apiPost = (yol, body, opts) => istek(yol, { ...(opts || {}), method: 'POST', body });
export const apiPut = (yol, body, opts) => istek(yol, { ...(opts || {}), method: 'PUT', body });
export const apiDelete = (yol, body, opts) => istek(yol, { ...(opts || {}), method: 'DELETE', body });

// Sorgu dizesi kurucu: bos/undefined degerleri atar
export function qs(params) {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
}
